import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getAcmgTranscript } from "../../../../../state/selectors/Pulsar.selectors";
import { aminoacidsLong } from "../../../constants/aminoacids";

function TranscriptLabelInfo({ item, acmgTranscript }) {
  if (!item) return null;

  const isACMG = item.transcriptName === acmgTranscript;

  const utr5Label = item.exonTypeIndex === 1 ? "5' UTR" : "";
  const utr3Label = item.exonTypeIndex === 2 ? "3' UTR" : "";
  const utrLabel = utr5Label || utr3Label || "";

  return (
    <div className="color-2 bg-3 tw-rounded-sm tw-flex tw-items-center tw-justify-center tw-text-2xs tw-px-1">
      <div className="tw-relative">{item.transcriptName}</div>
      {item.isMane ? (
        <span className="tw-text-orange-500 tw-text-3xs tw-font-semibold tw-pl-2">
          MANE
        </span>
      ) : null}
      {item.isCanonical ? (
        <span className="tw-text-blue-500 tw-text-3xs tw-font-semibold tw-pl-2">
          CANONICAL
        </span>
      ) : null}

      {item.exonIndex ? (
        <span className="tw-font-bold tw-pl-2">
          <span className="tw-text-3xs tw-opacity-50">exon:</span>
          <span className="tw-text-blue-500 tw-pl-1">{item.exonIndex}</span>
        </span>
      ) : null}

      {utrLabel ? (
        <span className="tw-font-bold">
          <span className="tw-font-semibold tw-text-blue-500">
            , {utrLabel}
          </span>
        </span>
      ) : null}

      {item.codonIndex ? (
        <span className="tw-font-bold tw-pl-2">
          <span className="tw-text-3xs tw-opacity-50">codon:</span>
          <span className="tw-text-blue-500 tw-pl-1">
            {item.codonIndex}, {aminoacidsLong[item.aminoAcid]}
          </span>
        </span>
      ) : null}

      {isACMG ? (
        <span className="color-1 tw-opacity-50 tw-pl-2">
          (Transcript used in Germ. classification component)
        </span>
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    acmgTranscript: getAcmgTranscript(state),
  };
};

TranscriptLabelInfo.propTypes = {
  acmgTranscript: PropTypes.string,
  item: PropTypes.shape({
    geneSymbol: PropTypes.string,
    transcriptName: PropTypes.string,
    isMane: PropTypes.bool,
    exonTypeIndex: PropTypes.number,
    isCanonical: PropTypes.bool,
    exonIndex: PropTypes.number,
    codonIndex: PropTypes.number,
    aminoAcid: PropTypes.string,
  }),
};

TranscriptLabelInfo.defaultProps = {
  item: null,
  acmgTranscript: null,
};

const Comp = React.memo(TranscriptLabelInfo);

export default connect(mapStateToProps)(Comp);
